export default {
  call: 'Ligar',
  text: 'SMS',
}
